export default __webpack_public_path__ + "static/media/ic_facebook.a3e108cb.svg";